<template>
  <div class="form-group">
    <slot name="label">
      <label v-if="label" :class="labelClasses">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
    </slot>
    <slot>
      <div :class="inline ? 'radio-inline' : 'radio-list'">
        <label
          class="radio"
          :class="[{ 'radio-outline': outline == 'true' }, 'radio-' + color]"
          v-for="(item, index) in items"
          :key="index"
        >
          <input
            v-bind="$attrs"
            type="radio"
            :checked="modelValue == item.key ? 'checked' : ''"
            :value="item.key"
            @change="$emit('input', item.key)"
            :name="name"
          />
          <span></span>
          {{ item.name }}
        </label>
      </div>
      <span v-if="helpText" class="form-text text-muted">{{ helpText }}</span>
    </slot>
  </div>
</template>
<script>
export default {
  name: 'base-radio',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      description: 'radio label',
    },
    name: {
      type: [String, Number],
      description: 'Radio label',
    },
    helpText: {
      type: String,
      description: 'Input help text (text after input)',
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes',
    },
    color: {
      type: String,
      description: 'checkbox color',
    },

    required: {
      type: Boolean,
      description: 'Whether radio is required (adds an asterix *)',
    },
    value: {
      description: 'Radio value',
    },
    name: { default: '' },
    modelValue: { default: '' },
    inline: {
      type: [Boolean, String],
      description: 'Whether radio is inline',
    },
    items: {
      type: Array,
      description: 'radio button items',
    },
    outline: {
      type: String,
      description: 'checkbox outline',
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
};
</script>
